<template>
  <div class="video">
    <video
      :src="payload.videoUrl"
      :poster="payload.thumbUrl"
      controls
      class="video"
      @error="videoError"
    ></video>
  </div>
</template>

<script>
export default {
  name: 'VideoElement',
  props: {
    payload: {
      type: Object,
      required: true
    },
    // message: {
    //   type: Object,
    //   required: true
    // },
    // isMine: {
    //   type: Boolean
    // }
  },
  mounted() {
    // console.log(this.payload);
  },
  methods: {
    videoError(e) {
      this.$message.fail('视频出错，错误原因：' + e.target.error.message)
    }
  }
}
</script>

<style lang="scss" scoped>
.video {
  width: 100%;
  max-height: 300px;
}
</style>
